<template>
  <div class="cover">
    <!-- 筛选项 -->
    <div class="screen">
      <el-checkbox
        :indeterminate="isIndeterminate"
        v-model="checkAll"
        @change="handleCheckAllChange"
        style="margin-right: 25px"
      >
        全选
      </el-checkbox>
      <el-checkbox-group
        v-model="checkedStates"
        @change="handleCheckedCitiesChange"
      >
        <el-checkbox v-for="state in states" :label="state" :key="state">
          {{ state }}
        </el-checkbox>
      </el-checkbox-group>
    </div>
    <div style="margin-top: 30px">
      <el-table :data="data" style="width: 100%" max-height="630" v-loading="loading" element-loading-text="数据加载中"
      :row-key="getRowKeys"
      :expand-row-keys="expands"
      @row-click="clickRowHandle"
      row-class-name="group_table_row"
      >
        <el-table-column
          type="index"
          label="序号"
          align="center"
          :index="indexMethod"
        >
        </el-table-column>
        <el-table-column label="作业名称" prop="work_name" align="center">
        </el-table-column>
        <el-table-column type="expand" label="详情">
          <template slot-scope="props">
            <el-table
              :data="props.row.essays.filter(handleFilter)"
              max-height="300"
            >
              <el-table-column type="index" label="序号" align="center">
              </el-table-column>
              <el-table-column label="任务类型" align="center"
                >作文批改</el-table-column
              >
              <el-table-column
                label="任务领取时间"
                prop="commit_time"
                align="center"
                :formatter="dateFormat"
              >
              </el-table-column>
              <el-table-column
                label="学生姓名"
                prop="author_name"
                align="center"
              >
              </el-table-column>
              <el-table-column label="状态" prop="state"> </el-table-column>
              <el-table-column
                label="分值"
                prop="score"
                align="center"
                :formatter="scoreFormat"
                width="110"
              >
              </el-table-column>
              <el-table-column label="操作" align="center" width="110">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.operation.ocr"
                    @click="handleOcr(scope.row)"
                    type="text"
                    size="small"
                    :disabled="
                      scope.row.operation.ocr === undefined ||
                      (scope.row.operation.ocr &&
                        scope.row.operation.ocr === 'n')
                    "
                  >
                    识别
                  </el-button>
                  <el-button
                    :disabled="
                      scope.row.operation.correct &&
                      scope.row.operation.correct === 'n'
                    "
                    @click="handleCorrect(scope.row)"
                    type="text"
                    size="small"
                  >
                    批改
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        :current-page="pageNum"
        :page-size="pageSize"
        layout="total,  prev, pager, next, jumper"
        :total="data.length"
        @current-change="handleCurrentChange"
        style="text-align: center"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { home } from "@/api";
const stateOptions = ["已批改", "批改中", "待批改"];
export default {
  data() {
    return {
      checkAll: true,
      checkedStates: ["已批改", "批改中", "待批改"], // 已选中筛选项
      states: stateOptions,
      isIndeterminate: false, // false --- 全选状态
      pageNum: 1, // 当前页数
      pageSize: 10, // 每页显示条目数
      data: [],
      loading: true,
      expands: []
    };
  },
  props: {
    list: Array,
  },
  watch: {
    list: {
      handler (newList, _) {
        if(newList.length >= 0){
          this.loading = false;
        }
        this.data = newList;
      },
      deep: true // 深度监听父组件传过来对象变化
    },
  },
  components: {},
  mounted() {},
  methods: {
    getRowKeys(row) {
      return row.essays[0].essay_id;
    },
    clickRowHandle(row,column,event) {
      if(this.expands.includes(row.essays[0].essay_id)) {
        this.expands = this.expands.filter(val => val !== row.essays[0].essay_id);
      } else {
        this.expands.push(row.essays[0].essay_id);
      }
    },
    init() {},
    // 全选操作
    handleCheckAllChange(val) {
      this.checkedStates = val ? stateOptions : [];
      this.isIndeterminate = false;
    },
    // 筛选项变化时的回调
    handleCheckedCitiesChange(value) {
      this.checkedStates = [];
      value.map((item) => {
        this.checkedStates.push(item);
      });
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.states.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.states.length;
    },
    // 表格数据过滤
    handleFilter(value) {
      if (this.checkedStates.length > 0) {
        for (let i = 0; i < this.checkedStates.length; i += 1) {
          if (value.state === this.checkedStates[i]) {
            return value;
          }
        }
      } else {
        console.log("无筛选条件");
      }
    },
    // 作文批改操作
    handleCorrect(row) {
      home
        .check({ id: row.essay_id, mode: 1 })
        .then((res) => {
          if (res.data.retcode === 0) {
            this.$router.push({
              path: "correct",
              query: { id: row.essay_id, activeIndex: "myTasks" },
            });
          } else if (res.data.retcode === 1 || res.data.retcode === 2) {
            this.$alert(res.data.retmsg, "登录异常", {
              confirmButtonText: "确定",
              callback: (action) => {
                this.clearCache();
              },
            });
          } else {
            this.$alert(res.data.retmsg, "请求失败", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // ocr图片识别操作
    handleOcr(row) {
      this.$router.push({
        path: "ocr",
        query: { id: row.essay_id, activeIndex: "myTasks" },
      });
    },

    // 内层表格时间格式修改
    dateFormat(row, column, cellValue) {
      var fecha = require("fecha");
      return cellValue
        ? fecha.format(new Date(cellValue), "YYYY-MM-DD HH:mm:ss")
        : "";
    },
    // 内层表格分数格式修改
    scoreFormat(row, column, cellValue) {
      return cellValue === null ? "/" : cellValue;
    },
    // 外层表格序号样式修改
    indexMethod(index) {
      return (
        <div style="height:20px;width:20px;background:#000;color:#fff;border-radius: 20px;line-height: 20px;">
          {index + 1}
        </div>
      );
    },
    // 分页栏事件
    handleCurrentChange(val) {
      this.pageNum = val;
    },
    // handleSizeChange(val) {
    //   this.pageSize = val;
    // }
  },
};
</script>
<style scoped>
.cover {
  margin: 0 auto;
  background: #fff;
  /* border: 1px solid #f00; */
}
.screen {
  display: flex;
  border-bottom: 1px solid #9e9e9e;
  height: 50px;
  line-height: 50px;
}
</style>
<style>
.el-table__expand-icon > .el-icon {
  font-size: 25px;
  font-weight: bold;
  margin-top: -13px;
  margin-left: -10px;
}
.el-table tr.group_table_row:hover > td {
  background: #66b1ff;
}
</style>
